/**
 * Extract canonical media IDs from provider URLs (no SDK imports).
 */

export function extractYouTubeId(url) {
  if (!url || typeof url !== "string") return null;
  var trimmed = url.trim();
  // Bare video id (standard YouTube length)
  if (/^[A-Za-z0-9_-]{11}$/.test(trimmed)) {
    return trimmed;
  }
  var patterns = [
    /(?:youtube\.com\/watch\?(?:[^#]*&)?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtube\.com\/live\/|youtu\.be\/|youtube-nocookie\.com\/embed\/)([A-Za-z0-9_-]{6,})/i,
  ];
  for (var i = 0; i < patterns.length; i++) {
    var m = trimmed.match(patterns[i]);
    if (m && m[1]) return m[1];
  }
  return null;
}

export function extractVimeoId(url) {
  if (!url || typeof url !== "string") return null;
  var trimmed = url.trim();
  if (/^\d{6,12}$/.test(trimmed)) {
    return trimmed;
  }
  var m = trimmed.match(
    /(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/i
  );
  return m && m[1] ? m[1] : null;
}

/**
 * Unlisted/private Vimeo privacy hash (`h` query or path segment after the id).
 */
export function extractVimeoPrivacyHash(url) {
  if (!url || typeof url !== "string") return null;
  var trimmed = url.trim();
  var query = trimmed.match(/[?&]h=([a-zA-Z0-9]+)/);
  if (query && query[1]) return query[1];
  var path = trimmed.match(
    /(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)\/([a-zA-Z0-9]+)/i
  );
  return path && path[2] ? path[2] : null;
}

export function isYouTubeUrl(url) {
  return !!extractYouTubeId(url);
}

export function isVimeoUrl(url) {
  return !!extractVimeoId(url);
}
